import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    this.element.remove()
    window.dispatchEvent(new Event("close-popovers"))
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
